import {IMatomoConfig} from '../models/matomo-config.model';

/** Checks that the config names a Matomo tracker and a site */
export const isMatomoConfigured = (config: IMatomoConfig): boolean => !!config.trackerUrl && !!config.siteId;
